<!-- <div class="gototop" (click)="pageScroller()"><img src="../../../assets/icon/gototop.svg" /></div> -->
<!DOCTYPE html>
<app-top-header></app-top-header>
@if (storePageData$ | async; as lotteryProducts) {
<ion-content #pageTop class="scrollbar no-scrollbar" (click)="hideCoachMark()"
  *ngIf="storePageDataOne$ | async as storePageDataOne ; else loading">
  <div class="page-background-blue">
    <ion-grid class="ion-no-padding">
      <ion-row class="credit-topup ion-padding-horizontal ion-align-items-center ion-justify-content-between">
        <div>
          @if (accountBalance$ | async; as accountBalance) {
          <p class="ion-no-margin">
            <img src="assets/icon/achievement_celebration/cash.webp" title="cash icon" loading="lazy" />
            {{storePageDataOne?.credit_bar?.title}} <strong>{{currencySymbol}}
              {{( accountBalance?.preferred_currency?.credit ?? accountBalance?.credit ?? 0) | displayCurrency
              }}</strong>
          </p>
          }
        </div>
        <div>
          @if (creditCTAStatus) {
          <ng-lottie [options]="creditCTAOptions" class="creditCTA-animation"
            (click)="onClick('get_credit_cta'); storeTopUp();"
            (animationCreated)="updateAnimationStatus('get_credit_cta', creditCTADuration);"></ng-lottie>
          }
          <button (click)="storeTopUp()" class="top-up-button">
            {{storePageDataOne?.credit_bar?.cta_label}}
          </button>
        </div>
      </ion-row>
      <ion-row class="store-padding">
        @if (show$ | async) {
        <div class="tooltip-wrapper" (click)="hideCoachMark()">
          @if (storeToolTip$ | async; as tooltip) {
          <div class=" tooltip-icon">
            <span class="tooltip-ic">{{tooltip[creditToolTip]?.icon}}</span>
          </div>
          <div class="tooltip-content">
            <h3 class="tooltip-title">{{tooltip[creditToolTip]?.content?.[selectedLanguage]?.title}}</h3>
            <p class="tooltip-desc">{{tooltip[creditToolTip]?.content?.[selectedLanguage]?.description}}</p>
          </div>
          }
        </div>
        }
      </ion-row>
      <ion-row style="margin-top: 10px">
        <!--Cards Slider-->
        <swiper [config]="storeSliderOptions" #storePageCardSlider (resize)="storePageCardSlider.update()"
          (swiper)="onStoreCardSwiper($event)">
          <!-- bundle Promotion card start -->
          @for (slide of storePageDataOne?.store_banners?.slides; track slide) {
          <ng-template swiperSlide>
            <!-- Custom Promotion card end -->
            @if (slide?.slide_info?.slide_type === "special") {
            <div class="retool-first-card retool-card-bg cursor-pointer" (click)="RetoolCardCta(slide?.slider?.cta_url)"
              [style.background]="getSafeBackground(slide?.slide_info?.background)"
              [ngClass]="!storePageDataOne?.store_banners?.slides ? 'custom-retool-card' : ''">
              <div class="overlay-2 single-overlay">
                <div class="adjusted-column-sizes">
                  <div class="column-60" [ngClass]="(!slide?.slider?.lottery_name &&  
                  slide?.slider?.custom_text === '' && 
                  slide?.slider?.title) ? 'custom-retool' : ''">
                    <div class="discount-section desktop-view">
                      @if (slide?.discount_value) {
                      <span>{{slide?.slide_info?.discount_value}}</span>
                      }
                    </div>
                    @if(slide?.slider?.custom_text !=''){
                    <div class="card-price price-style"
                      [ngClass]="slide?.slider?.title != '' && slide?.slider?.title?.length < 25 ? 'vertical-padding-first' : 'vertical-padding-second'"
                      [innerHTML]="slide?.slider?.custom_text | safeHtml">
                    </div>
                    } @else {
                    <div class="card-price price-style"
                      [ngClass]="slide?.slider?.title != '' && slide?.slider?.title?.length < 25 ? 'vertical-padding-first' : slide?.slider?.title != '' && slide?.slider?.title?.length > 25 ? 'vertical-padding-second' :''"
                      [ngStyle]="{ 
                        'color': slide?.slide_info?.jackpot_color && slide?.slide_info?.jackpot_color.trim() !== '' ? slide?.slide_info?.jackpot_color : undefined,                                      
                         'top': (slide?.slide_info?.jackpot_value !== null && 
                                 slide?.slider?.custom_text === '' && 
                                 slide?.slider?.title === '') ? '45px' : 'auto',
                         'position': (slide?.slide_info?.jackpot_value !== null && 
                                      slide?.slider?.custom_text === '' && 
                                      slide?.slider?.title === '') ? 'relative' : 'static',
                         'display': slide?.slider?.lottery_name === null ? 'none' : 'block',
                       }">
                      {{slide?.slide_info?.jackpot_value | formatJackpot}}</div>
                    }
                    <div class="card-description card-description-custom" [ngClass]="(!slide?.slide_info?.jackpot_value &&  
                                        slide?.slider?.custom_text === '' && 
                                        slide?.slider?.title) 
                                          ? 'top-35' 
                                          : ''" [innerHTML]="slide?.slider?.title |safeHtml"></div>
                  </div>
                  <div class="column-40">
                    <div [ngClass]="{'image-container-2': slide?.isRadialEffectShow}" class="redical-position">
                      @if (slide?.slider?.image_url) {
                      <img alt="Lottery icon" class="product_image" [src]="slide?.slider?.image_url" loading="lazy" />
                      }
                    </div>
                  </div>
                  <ion-button class="card-cta btn-retool-cta">{{slide?.slider?.cta_label}}</ion-button>
                  @if (slide?.isCountdownShow) {
                  <div class="retool-timer">
                    <span class="promo-timer-text">
                      {{checkForJackpotDrawDate(slide?.slide_info?.expiry_date?.seconds)}}
                    </span>
                  </div>
                  }
                  @if(slide?.slide_info?.discount_value) {
                  <div class="discount-Offer">
                    <span>{{slide?.slide_info?.discount_value}}</span>
                  </div>
                  }
                </div>
              </div>
            </div>
            } @else if (slide.slide_info?.style === 'custom') {
            <div class="retool-first-card cursor-pointer" (click)="openOffer(slide)"
              [style.background]="slide?.slide_info?.background">
              <div class="overlay-2 single-overlay">
                <!-- Adjusted column sizes -->
                <div class="adjusted-column-sizes">
                  <div class="column-60">
                    <div class="retool-span">
                      <img class="timer-icon" src="../../../assets/icon/timer-light.svg" alt="timer icon"
                        loading="lazy" />
                      <app-count-down-timer class="custom-promo-timer-text"
                        [end]="slide?.slide_info?.expiry_date?.seconds"
                        [sec]="slide?.slide_info?.expiry_date?.nanoseconds" type="seconds">
                      </app-count-down-timer>
                    </div>
                    <div class="discount-section desktop-view">
                      @if (slide?.slide_info?.discount_value) {
                      <span>{{slide?.slide_info?.discount_value}}</span>
                      }
                    </div>
                    <div class="card-price">{{slide?.slide_info?.jackpot_value | formatJackpot}}</div>
                    <div class="card-description">&nbsp; </div>
                    <ion-button class="card-cta">{{slide?.slider.cta_description}}</ion-button>
                  </div>
                  <div class="column-40">
                    <div class="image-container two-ball-div">
                      @if (slide?.slider.product_lottery_icon_1) {
                      <img alt=" Lottery icon"
                        [ngClass]="slide?.slider.product_lottery_icon_2 ? 'first-ball' : 'product_image'"
                        [src]="slide?.slider.product_lottery_icon_1" loading="lazy" />
                      }
                      @if (slide?.slider.product_lottery_icon_2) {
                      <img alt=" Lottery icon"
                        [ngClass]="slide?.slider.product_lottery_icon_1 ? 'second-ball' : 'product_image'"
                        [src]="slide?.slider.product_lottery_icon_2" loading="lazy" />
                      }
                    </div>
                    @if (slide?.discount_available && slide?.isOneOff) {
                    <div class="discount-icon-section">
                      <span class="discount-icon">
                        <img src="assets/images/ticket.png" alt="ticket" loading="lazy"/>
                      </span>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            } @else if (slide?.slide_info?.style === 'custom_combo') {
            <div class="retool-first-card cursor-pointer custom-combo" (click)="openOffer(slide)"
              [ngStyle]="{'background-image': 'url(' + slide?.slider?.product_image + ')'}">
              <div class="overlay-2 single-overlay">
                <!-- Adjusted column sizes -->
                <div class="adjusted-column-sizes">
                  <div class="column-60">
                    <div class="retool-span">
                      <h5 class="combo_title">{{slide?.slider?.product_title}}</h5>
                    </div>
                    <div class="carousel-timer-wrapper-combo">
                      <app-new-count-down-timer class="remaining-time-slider"
                        end="{{ slide?.slide_info?.expiry_date?.seconds }}" type="seconds"></app-new-count-down-timer>
                    </div>
                    <div class="discount-section desktop-view">
                      @if (slide?.slide_info?.discount_value) {
                      <span class="custom-combo-discount">{{slide?.slide_info?.discount_value}} {{'store.off' |
                        translate}}</span>
                      }
                    </div>
                    <div class="card-price combo-offer">{{slide?.slide_info?.jackpot_value | formatJackpot}}</div>
                    <div class="card-description">&nbsp; </div>
                    <ion-button class="card-cta">{{slide?.slider?.cta_description || ('store.play_now' |
                      translate)}}</ion-button>
                  </div>
                </div>
                @if (slide?.discount_available) {
                    <div class="discount-icon-section">
                      <span class="discount-icon">
                        <img src="assets/images/ticket.png" alt="ticket" loading="lazy"/>
                      </span>
                    </div>
                  }
              </div>
            </div>
            } @else if (slide.slide_info?.style === flashSaleStyleString) {
            <div class="retool-first-card cursor-pointer" (click)="openOffer(slide)"
              [style.background]="slide?.slide_info?.background">
              <div class="overlay-2 single-overlay">
                <div class="adjusted-column-sizes">
                  <div class="column-60">
                    <div class="retool-span">
                      <img class="timer-icon" src="../../../assets/icon/timer-light.svg" alt="timer icon"
                        loading="lazy" />
                      <app-count-down-timer class="custom-promo-timer-text"
                        [end]="slide?.slide_info?.expiry_date?.seconds"
                        [sec]="slide?.slide_info?.expiry_date?.nanoseconds" type="seconds">
                      </app-count-down-timer>
                    </div>
                    <div class="discount-section desktop-view">
                      <span *ngIf="slide?.slide_info?.discount_value">{{slide?.slide_info?.discount_value}}</span>
                    </div>
                    <div class="card-flash-title">{{slide?.slider?.content?.[selectedLanguage]?.product_title}}</div>
                    <div class="card-flash-description">{{slide?.slider?.content?.[selectedLanguage]?.line_description}}
                    </div>
                    <ng-lottie *ngIf="firstProductStatus && i == 0" [options]="firstProductOptions"
                      class="firstCard-animation"></ng-lottie>
                    <ion-button class="card-cta"
                      (click)="openOffer(slide)">{{slide?.slider?.content?.[selectedLanguage]?.button_label}}</ion-button>
                  </div>
                  <div class="column-40">
                    <div class="image-container two-ball-div">
                      <img *ngIf="slide?.slider.product_lottery_icon_1" alt=" Lottery icon"
                        [ngClass]="slide?.slider.product_lottery_icon_2 ? 'first-ball' : 'product_image'"
                        [src]="slide?.slider.product_lottery_icon_1" loading="lazy" />
                      <img *ngIf="slide?.slider.product_lottery_icon_2" alt=" Lottery icon"
                        [ngClass]="slide?.slider.product_lottery_icon_1 ? 'second-ball' : 'product_image'"
                        [src]="slide?.slider.product_lottery_icon_2" loading="lazy" />
                    </div>
                    <div class="flash-container">
                      <div class="flash-sale">
                        <p class="flash-title">{{slide?.slider?.content?.[selectedLanguage]?.cta_description}}</p>
                        <div class="flash-timer" [ngStyle]="{ width: flashSaleWidth$ | async }">
                          <p>
                            <app-count-down-timer class="custom-promo-timer-text"
                              [end]="slide?.slide_info?.expiry_date?.seconds"
                              [sec]="slide?.slide_info?.expiry_date?.nanoseconds" type="seconds">
                            </app-count-down-timer>
                          </p>
                        </div>
                        <img src="./../../../assets/images/flash_icon.webp" alt="flash_icon" loading="lazy">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            } @else if (slide?.slide_info?.style === 'daily') {
            <div class="store-card cursor-pointer" (click)="openOffer(slide)">
              <ion-row>
                <ion-col size="12" class="image-div">
                  <ion-row class="lotter-icons">
                    <ion-col size="5">
                      @if (slide?.slider.product_lottery_icon_1) {
                      <img [src]="slide?.slider.product_lottery_icon_1" loading="lazy" />
                      }
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row>
              <div class="overlay">
                <h1 class="slide-title">
                  {{ slide?.slider?.product_title ? slide.slider.product_title : lottery_name }}
                </h1>
                <div class="store-price">🔥{{ slide?.slide_info?.jackpot_value | formatJackpot }}
                </div>
                <div class="bundle-description">
                  {{slide?.slider.line_description}} <br />
                  {{slide?.slider.discount_description}}<br />
                  <span>
                    <app-count-down-timer end="{{ slide?.slide_info?.expiry_date?.seconds }}"
                      sec="{{ slide?.slide_info?.expiry_date?.nanoseconds }}" type="seconds">
                    </app-count-down-timer>
                  </span>
                </div>
                <div class="discount-section desktop-view">
                  <span>{{slide?.slide_info?.discount_value}}</span>
                </div>
              </div>
            </div>
            } @else if (slide?.slide_info?.style === 'bundle') {
            <div class="store-card cursor-pointer" (click)="openOffer(slide)">
              <ion-row>
                <ion-col size="12" class="image-div">
                  @if (slide?.slider.product_image) {
                  <img [src]="slide?.slider.product_image" loading="lazy" />
                  }
                  <ion-row class="lotter-icons">
                    <ion-col size="5">
                      @if (slide?.slider.product_lottery_icon_1) {
                      <img [src]="slide?.slider.product_lottery_icon_1" loading="lazy" />
                      }
                    </ion-col>
                    <ion-col size="2" class="separate-plus-icon"> + </ion-col>
                    <ion-col size="5">
                      @if (slide?.slider.product_lottery_icon_2) {
                      <img [src]="slide?.slider.product_lottery_icon_2" loading="lazy" />
                      }
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row>
              <div class="overlay">
                <h1 class="slide-title">
                  {{ slide?.slider?.product_title ? slide.slider.product_title : lottery_name }}
                </h1>
                <div class="store-price">🔥{{slide?.slide_info?.jackpot_value | formatJackpot}}
                </div>
                <div class="bundle-description">
                  {{slide?.slider?.line_description}} <br />
                  <span [innerHTML]="slide?.slider?.discount_description"></span>
                  <span class="carousel-timer-wrapper">
                    <img src="../../../assets/icon/timer-light.svg" class="carousel-clock-image" loading="lazy" />
                    <app-count-down-timer end="{{ slide?.slide_info?.expiry_date?.seconds }}"
                      sec="{{ slide?.slide_info?.expiry_date?.nanoseconds }}" type="seconds">
                    </app-count-down-timer>
                  </span>
                </div>
                <div class="discount-section desktop-view">
                  <span>{{slide?.slide_info?.discount_value}}</span>
                </div>
              </div>
            </div>
            }
          </ng-template>
          }
        </swiper>
        <ion-col sizeSm="4" sizeLg="4" class="cardPager">
          <button (click)="slidePrev()" class="nav-prev-icon">
            <ion-icon name="chevron-back-outline"></ion-icon>
          </button>
        </ion-col>
        <ion-col sizeSm="2" sizeLg="4" class="cardPager">
          <div class="swiper-pagination_"></div>
        </ion-col>
        <ion-col sizeSm="6" sizeLg="4" class="cardPager">
          <button (click)="slideNext()" class="nav-next-icon">
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </button>
        </ion-col>
      </ion-row>
      <div id="ct-nat-store"></div>
      @if (isPushNotification()) {
      <app-push-notification-banner [notificationData]="inlineNotificationDetails"></app-push-notification-banner>
      } @else if (isAddHomeScreen()) {
      <app-add-home-screen-banner [notificationData]="inlineNotificationDetails"></app-add-home-screen-banner>
      } @else {
      @if (inlineNotificationDetails && inlineNotificationDetails?.content) {
      <div class="push-notification"
        [ngClass]="{ 'main-head-notification': inlineNotificationDetails?.style === 'promotional' }"
        [style.background]="inlineNotificationDetails?.style === 'promotional' ? inlineNotificationDetails?.background : null">
        <div class="notification-header">
          <div class="header">
            <div class="bell-wrapper">
              <img [src]="getIconUrl(inlineNotificationDetails?.icon_url)" alt="Bell icon" loading="lazy"
                class="inline_icon_width" />
            </div>
            <p [innerHTML]="inlineNotificationDetails?.content?.title"></p>
          </div>
          <img
            [src]="'assets/icon/' + (inlineNotificationDetails?.style === 'promotional' ? 'close-circle.svg' : 'close-gray.webp')"
            alt="Close Notification" class="close-notify" loading="lazy" (click)="dismissFeedback()" />
        </div>
        <div class="notify-content">
          <div>
            <p class="content-title title-description" [innerHTML]="inlineNotificationDetails?.content?.line_1"></p>
            <p class="content-subtitle" [innerHTML]="inlineNotificationDetails?.content?.line_2"></p>
          </div>
          <button class="active-btn" type="button" [ngClass]="{ 'with-countdown': countdownSeconds }" 
            [disabled]="isVoucherClaimedSignal()"
            (click)="onInlineNotification(inlineNotificationDetails)">

            {{ inlineNotificationDetails?.content?.button_label }}
            @if (countdownSeconds) {
            <span class="timer-text">{{ voucherNotificationService.claimTimerDisplay }}</span>
            }
          </button>
          @if (countdownSeconds) {
          <countdown-timer [seconds]="countdownSeconds"
            (formattedTime)="voucherNotificationService.claimTimerDisplay = $event" (countdownFinished)="handleCountdownFinish()">
          </countdown-timer>
        }
        </div>
      </div>
      }
      }
      <ion-row class="list-wrapper-background">
        <!--Jackpot List-->
        <div class="jackpot-items">
          @if (triggerActivationStatus()) {
          <ng-lottie width="70%" [options]="jackpotTriggerAnimationOptions" class="jackpot-trigger-animation"
            (complete)="onAnimationComplete()"></ng-lottie>
          }
          @for (lotteryProduct of storePageData; track lotteryProduct; let i = $index) {
          <ion-item lines="none" class="total-list-container">
            <ion-grid class="ion-no-padding splitter-line">
              <ion-row class="jackpot-container splitter-line-bottom"
                (click)="onClick('first_product_card'); openProduct(lotteryProduct)">
                <ion-col size="2">
                  @if (lotteryProduct?.image_url) {
                  <img class="jackpot-logo" [src]="lotteryProduct?.image_url" loading="lazy" alt="lottery" />
                  }
                </ion-col>
                <ion-col size="10">
                  <ion-row>
                    <ion-col size="6" class="ion-align-self-center">
                      <div class="jackpot-discount">
                        <h3 class="jackpot-name">{{lotteryProduct?.real_name}}</h3>
                        @if (lotteryProduct?.discount_available){
                        <img src="assets/images/ticket.png" alt="ticket" loading="lazy" />
                        }
                      </div>            
                      @if (lotteryProduct?.lottery_lines) {
                      <p class="lines-available">
                        {{lotteryProduct?.lottery_lines}}</p>
                      }
                      @else {
                        @let lines = getLotteryLines(lotteryProduct?.real_name);
                        @if (lines) {
                        <p class="lines-available">
                          {{ lines }}
                        </p>
                        }
                      }
                      @if (firstProductStatus && i == 0) {
                      <ng-lottie [options]="firstProductOptions" class="firstCard-animation"
                        (click)="onClick('first_product_card');"
                        (animationCreated)="updateAnimationStatus('first_product_card', firstProductDuration);"></ng-lottie>
                      }
                    </ion-col>
                    <ion-col class="jackpot-right-col" size="6">
                      <h3 class="jackpot-amount">
                        @if (lotteryProduct?.jackpot_value && lotteryProduct.featured===true) {
                        <span class="fire-icon">🔥</span>
                        }
                        {{lotteryProduct?.jackpot?.int_jackpot_value?.[preferredCurrency] ??
                        lotteryProduct?.jackpot?.jackpot_value ?? lotteryProduct?.jackpot_value}}
                      </h3>
                      <div class="timer-wrap">
                        <h1 class="clock-image"><img src="https://app.lottosocial.com/assets/icon/timer.webp"
                            class="clock-ic" loading="lazy" /></h1>
                        <app-count-down-timer class="remaining-time" end="{{lotteryProduct?.expiry_date?.seconds}}"
                          type="seconds">
                        </app-count-down-timer>
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row>
              @if (i===1 && (jackpotTriggers$ | async)?.length > 0 &&
              storePageDataOne?.jackpot_triggers?.triggers?.length > 0) {
              <ion-row id="jackpot_trigger" #jackpot_trigger class="banner" (click)="showDiv(showDivSlider)">
                <ion-row>
                  <ion-col>
                    <div class="trigger-div ion-align-items-center">
                      <p class="trigger-title">{{storePageDataOne?.jackpot_triggers?.title}}</p>
                      <img src="../../../assets/icon/trigger-energy.webp" alt="" class="trigger-img" loading="lazy" />
                    </div>
                    <p class="reserve-jackpot" [innerHTML]="storePageDataOne?.jackpot_triggers?.description | safeHtml">
                    </p>
                  </ion-col>
                </ion-row>
              </ion-row>
              }
              <!-- Update JPT banner design and content start -->
              @if (i===1 && (jackpotTriggers$ | async)?.length > 0 &&
              storePageDataOne?.jackpot_triggers?.triggers?.length > 0) {
              <ion-row>
                <swiper (sliderMove)="showTool=false" class="store-slider-trigger" [config]="storeSliderOptions2"
                  #slider (swiper)="onJackpotSwiper($event)" (slideChange)="onSlideChange()">
                  @for (data of jackpotTriggers$ | async; track data) {
                  <ng-template swiperSlide>
                    <div class="jpt-banner" [style.background]="data?.background">
                      <div class="overlay-2 single-overlay">
                        <!-- Adjusted column sizes -->
                        <div class="adjusted-column-sizes">
                          <div class="column-60">
                            <div class="card-title">
                              <p>
                                @if (data && data?.storeType=='free') {
                                <strong>
                                  {{data?.content?.title}}</strong>
                                }
                                <br>
                                {{data?.content?.description}}
                              </p>
                              <strong class="card-desc">
                                {{data?.content?.slogan}}</strong>
                            </div>
                            @switch (data && data?.storeType) {
                            @case ('free') {
                            <ion-button class="card-cta" [disabled]="isJptActived()" (click)="activateJackpotTrigger(data)">
                              {{data?.content?.cta_label}}
                            </ion-button>
                            }
                            @case ('std') {
                            <ion-button class="card-cta" [disabled]="isJptActived()" (click)="activateJackpotTrigger(data)">
                              {{'JPT.get_lines' | translate}}
                            </ion-button>
                            }
                            @default {
                            <ion-button class="card-cta" [disabled]="isJptActived()" (click)="activateJackpotTrigger(data)">
                              {{'JPT.get_lines' | translate}}
                            </ion-button>
                            }
                            }
                          </div>
                          <div class="column-40">
                            <img src="../../../assets/icon/info_icon.svg" class="info-icon" alt=""
                              (click)="showTriggerDetails(data)">
                            <div class="image-wrapper">
                              @if (data?.jackpot_image) {
                              <img alt="Lottery icon" [src]="data?.jackpot_image" loading="lazy" />
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  }
                </swiper>
                <ion-row class="my-custom-pager">
                  <ion-col sizeSm="4" sizeLg="4" class="pager-2">
                    <button (click)="prev()" class="nav-prev-icon-euro">
                      <ion-icon name="chevron-back-outline"></ion-icon>
                    </button>
                  </ion-col>
                  <ion-col sizeSm="2" sizeLg="4" class="pager-2">
                    <div class="swiper-pagination-2"></div>
                  </ion-col>
                  <ion-col sizeSm="4" sizeLg="4" class="pager-2">
                    <button (click)="next()" class="nav-next-icon-euro">
                      <ion-icon name="chevron-forward-outline"></ion-icon>
                    </button>
                  </ion-col>
                </ion-row>
                <!-- Update JPT banner design and content end -->
              </ion-row>
              }
            </ion-grid>
          </ion-item>
          }
        </div>
      </ion-row>
    </ion-grid>
    <!-- tooltip content -->
    @if (showTool) {
    <div class="newTootip">
      <p (click)="goToSyndicate()">{{'store.jackpot_trigger_message' | translate}}</p>
    </div>
    }
  </div>
</ion-content>
} @else {
<app-in-progress-animation type="storloading"></app-in-progress-animation>
}

<ng-template #loading>
  <app-in-progress-animation type="storloading"></app-in-progress-animation>
</ng-template>
